import { render, staticRenderFns } from "./PolimixQualityAppraisal.vue?vue&type=template&id=47a40c38&"
import script from "./PolimixQualityAppraisal.vue?vue&type=script&lang=js&"
export * from "./PolimixQualityAppraisal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports